import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";

export default function MangaCard({ manga }: { manga: Manga }) {
  return (
    <Link
      to={`/article/${manga.id}`}
      className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:shadow-soft"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={manga.cover}
          alt={`${manga.title} ${manga.tags.join(" ")}`}
          className="h-full w-full object-cover object-top transition duration-300 group-hover:scale-105"
        />
        <span className="absolute left-2.5 top-2.5 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {manga.season}
        </span>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-full bg-accent-500 px-2 py-1 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {manga.rating}
        </span>
      </div>
      <div className="p-3.5">
        <h3 className="truncate text-sm font-bold text-foreground-900 md:text-base">
          {manga.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {manga.tags.map((t) => (
            <span
              key={t}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {t}
            </span>
          ))}
        </div>
        <p className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-refresh-line"></i>
          {manga.update}
        </p>
      </div>
    </Link>
  );
}